"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyItems = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _reactSvg = require("react-svg");
var _reactI18next = require("react-i18next");
var _lodash = _interopRequireDefault(require("lodash"));
var _clsx = _interopRequireDefault(require("clsx"));
var _pittaModules = require("@thingsw/pitta-modules");
var _DashcamEmptyIcon = require("../icons/DashcamEmptyIcon");
var _Typography = require("./Typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(_ref) {
      var variant = _ref.variant;
      return _objectSpread(_objectSpread({
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }, variant === "small" ? {
        margin: "auto 0px"
      } : {
        margin: theme.spacing(2, 0)
      }), {}, {
        flexGrow: 1
      });
    },
    noItemDiv: function noItemDiv(_ref2) {
      var variant = _ref2.variant;
      return variant === "small" ? {} : {
        marginTop: "18.75vh"
      };
    },
    noCamText: function noCamText(_ref3) {
      var variant = _ref3.variant;
      return variant === "small" ? {
        marginTop: theme.spacing(0.5)
      } : {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
      };
    },
    noItemIcon: function noItemIcon(_ref4) {
      var variant = _ref4.variant;
      return variant === "small" ? {
        width: 140,
        height: 140
      } : {
        width: 200,
        height: 200
      };
    },
    cameraText: {
      marginTop: 0
    },
    textCenter: {
      textAlign: "center",
      padding: "0 16px"
    }
  };
});
var EmptyItems = function EmptyItems(props) {
  var classes = useStyles(props);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var variant = props.variant,
    mode = props.mode,
    noCamTextClassName = props.noCamTextClassName;
  var icon = (0, _react.useMemo)(function () {
    if (mode === "camera" || mode === "groupCam") {
      return /*#__PURE__*/_react.default.createElement(_DashcamEmptyIcon.DashcamEmptyIcon
      // mantis - 10505, 아이콘 색상 검정->회색 수정 (Leehj)
      , {
        style: {
          width: 60,
          height: 60,
          color: _pittaModules.LightColors.primary["4"]
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
      src: "/images/noItem.svg",
      className: classes.noItemDiv,
      beforeInjection: function beforeInjection(svg) {
        var _svg$classList;
        (_svg$classList = svg.classList).add.apply(_svg$classList, _toConsumableArray(_lodash.default.split(classes.noItemIcon, " ")));
      }
    });
  }, [classes.noItemDiv, classes.noItemIcon, mode]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, icon, mode === "notifications" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: (0, _clsx.default)(classes.noCamText, noCamTextClassName),
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No notifications yet")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "Small" : "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("Notifications will show_"))), mode === "geofences" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: classes.noCamText,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No geofences yet")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "Small" : "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("Geofences will show_"))), mode === "routes" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: classes.noCamText,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No routes to_")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "Small" : "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("It will show_"))), mode === "member" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: classes.noCamText,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No members yet")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "Small" : "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("Members will show_"))), mode === "geofence-alert" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: classes.noCamText,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No geofence alert"))), (mode === "camera" || mode === undefined) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: (0, _clsx.default)(classes.noCamText, classes.cameraText),
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No cameras yet")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "Small" : "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("Cameras will show_"))), mode === "liveView" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "BodyBold" : "H6",
    className: classes.noCamText,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No cameras to_")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: variant === "small" ? "Small" : "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("You have added_"))), mode === "groupCam" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "BodyBold",
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("No cameras yet")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body",
    className: classes.textCenter,
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, t("Please assign cameras_"))));
};
exports.EmptyItems = EmptyItems;